import { FilterSectionType } from '../enum/FilterSectionType';

export const filerSectionsNonUs = [FilterSectionType.SecurityType];
